export const sdnTemplateToSubmission = (sdnTemplate) => {
  const Sections = sdnTemplate
    .map((sec) => ({
      InterfaceKey: sec.interfaceKey,
      Statements: sec.text.split("\n").filter((s) => s > ""),
    }))
    .filter((sec) => sec.Statements.length > 0);

  return { Sections };
};

export const sdnTemplateToSubmissionAdvised = (sdnTemplate) => {
  const Sections = [];
  const reasonBullets = [];

  sdnTemplate.forEach((sec) => {
    const bullets = [];

    sec.questions.forEach((question) => {
      if (!question.value) return;
      bullets.push(question.text);

      if (question.reason) reasonBullets.push(question.reason);

      if (!question.questions) return;
      question.questions.forEach((innerQuestion) => {
        if (!innerQuestion.value) return;
        bullets.push(innerQuestion.text);

        if (innerQuestion.reason) reasonBullets.push(innerQuestion.reason);
      });
    });

    if (sec.additionalText) {
      const additionalTextIntoBullets = sec.additionalText
        .split("\n")
        .filter((s) => s > "");

      bullets.push(...additionalTextIntoBullets);
    }

    Sections.push({
      InterfaceKey: sec.interfaceKey,
      Statements: bullets,
    });
  });

  Sections.push({
    InterfaceKey: "SuitabilityReasons",
    Statements: reasonBullets,
  });

  return { Sections };
};
